import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'EN' },
    { code: 'tr', name: 'TR' }
  ];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <div className="flex items-center bg-white/10 rounded-lg p-1 backdrop-blur-sm border border-white/20">
      {languages.map((language) => (
        <button
          key={language.code}
          onClick={() => handleLanguageChange(language.code)}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-all duration-200 ${
            i18n.language === language.code
              ? 'bg-white text-purple-600 shadow-sm'
              : 'text-white/70 hover:text-white hover:bg-white/10'
          }`}
        >
          {language.name}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher; 